export default "__VITE_ASSET__DBTx$3Qs__"